import React, { useState } from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const Testimonials = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].testimonials;
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % t.quotes.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + t.quotes.length) % t.quotes.length);
  };
  return <FadeInSection className="relative w-full py-32 lg:py-40 overflow-hidden" data-id="element-264">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-265">
        <img src="https://images.unsplash.com/photo-1570129477492-45c003edd2be" alt="Luxury Home Interior" className="w-full h-full object-cover" data-id="element-266" />
        <div className="absolute inset-0 bg-black/65" data-id="element-267" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 flex flex-col items-center text-center" data-id="element-268">
        <span className="eyebrow mb-4 text-white/90" data-id="element-269">{t.eyebrow}</span>
        <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-white mb-20" data-id="element-270">
          {t.headline}
        </h2>

        <div className="relative w-full min-h-[250px] flex items-center justify-center" data-id="element-271">
          {/* Navigation Arrows */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 text-[#c9a96e] hover:text-white transition-colors p-2 z-20 hidden md:block" data-id="element-272">
            <ChevronLeft size={48} strokeWidth={1} data-id="element-273" />
          </button>

          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 text-[#c9a96e] hover:text-white transition-colors p-2 z-20 hidden md:block" data-id="element-274">
            <ChevronRight size={48} strokeWidth={1} data-id="element-275" />
          </button>

          {/* Carousel Content */}
          <div className="w-full md:w-3/4 px-4" data-id="element-276">
            <AnimatePresence mode="wait" data-id="element-277">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} transition={{
              duration: 0.5
            }} className="flex flex-col items-center" data-id="element-278">
                <div className="flex space-x-1 mb-8" data-id="element-279">
                  {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-[#c9a96e] text-[#c9a96e]" data-id="element-280" />)}
                </div>

                <p className="font-serif-cormorant italic text-2xl md:text-4xl text-white leading-relaxed mb-10" data-id="element-281">
                  "{t.quotes[currentIndex].text}"
                </p>

                <span className="uppercase tracking-[0.2em] text-sm text-[#c9a96e] font-medium" data-id="element-282">
                  {t.quotes[currentIndex].author}
                </span>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="flex space-x-6 mt-12 md:hidden" data-id="element-283">
          <button onClick={prev} className="text-[#c9a96e]" data-id="element-284">
            <ChevronLeft size={32} strokeWidth={1} data-id="element-285" />
          </button>
          <button onClick={next} className="text-[#c9a96e]" data-id="element-286">
            <ChevronRight size={32} strokeWidth={1} data-id="element-287" />
          </button>
        </div>
      </div>
    </FadeInSection>;
};